// extracted by mini-css-extract-plugin
module.exports = {"container":"BenefitBox_container__xKhK8","mainBox":"BenefitBox_mainBox__i7OU0","text":"BenefitBox_text__x7xvG","icon":"BenefitBox_icon__9xNIx"};